import axios from 'axios';

const VERSION_KEY = 'app_version';
let checkingVersion = false;
let pollingTimer = null;

/**
 * 获取本地存储的版本号
 */
const getLocalVersion = () => {
  try {
    return localStorage.getItem(VERSION_KEY);
  } catch (e) {
    return null;
  }
};

/**
 * 设置本地版本号
 */
const setLocalVersion = (version) => {
  try {
    localStorage.setItem(VERSION_KEY, version);
  } catch (e) {}
};

/**
 * 强制刷新页面，在现有 URL 上追加版本号参数绕过钉钉 WebView 缓存
 * 保留原有的所有参数（如钉钉登录回调的 code 等），只替换 v 参数
 */
const forceReload = (version) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('v', version);
  const newUrl = window.location.origin + window.location.pathname + '?' + searchParams.toString() + window.location.hash;
  window.location.replace(newUrl);
};

/**
 * 判断是否为登录相关页面（登录页不触发强制刷新，避免中断登录流程）
 */
const isLoginPage = () => {
  const hash = window.location.hash.replace(/^#/, '');
  const path = hash.split('?')[0].toLowerCase();
  return path === '/login' || path === '/testlogin' || path === '';
};

/**
 * 检测版本更新
 * 每次路由切换时触发，当检测到版本不同时强制刷新页面
 */
const isNewVersion = () => {
  // 防止并发检测
  if (checkingVersion) return;
  checkingVersion = true;

  const url = `//${window.location.host}/version.json?t=${new Date().getTime()}`;

  axios.get(url).then(res => {
    checkingVersion = false;
    if (res.status === 200) {
      const serverVersion = res.data.version || '1.0.0';
      const localVersion = getLocalVersion();
      console.log('当前版本：', localVersion, '最新版本：', serverVersion);
      if (!localVersion || localVersion !== serverVersion) {
        setLocalVersion(serverVersion);
        // 登录页面不触发强制刷新，避免中断登录流程
        // 版本号已存储到 localStorage，登录成功后跳转主页时会自动触达
        if (!isLoginPage()) {
          setTimeout(() => {
            forceReload(serverVersion);
          }, 100);
        }
      }
    }
  }).catch(() => {
    checkingVersion = false;
  });
};

/**
 * 启动定时轮询版本检测（兜底方案）
 * 在钉钉环境中，用户可能长时间停留在同一页面不切换路由，定时检查确保能检测到版本更新
 * @param {number} interval 轮询间隔，默认 30 分钟
 */
const startVersionPolling = (interval = 30 * 60 * 1000) => {
  // 防止重复创建定时器
  if (pollingTimer) {
    clearInterval(pollingTimer);
  }
  pollingTimer = setInterval(() => {
    isNewVersion();
  }, interval);
};

export default {
  isNewVersion,
  startVersionPolling
}
